import React from "react";
import styles from "./Filter.module.css";

function Filter({ onChange }) {
  const handleFilterChange = (event) => {
    const value = event.target.value;
    onChange(value === "View All" ? "" : value); // "View All"이면 빈 문자열로 전달
  };

  return (
    <select onChange={handleFilterChange} className={styles.filter}>
      <option value="View All">List: View All</option>
      <option value="Neuromodulators/Neurotoxins">Neuromodulators/Neurotoxins</option>
      <option value="Fillers">Fillers</option>
      <option value="Facials">Facials</option>
      <option value="Microneedling">Microneedling</option>
      <option value="Laser & Energy Therapy">Laser & Energy Therapy</option>
      <option value="IV Drips & Vitamin injections">IV Drips & Vitamin Injections</option>
      <option value="Peeling">Peeling</option>
      <option value="Hair removal">Hair Removal</option>
    </select>
  );
}

export default Filter;
